'use client';

import { env } from '@/env';
import { client } from '@/lib/api';
import { type IntegrationManifest } from '@pigello/pigello-matrix';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

type UseIntegrationManifestsProps = Omit<
  UseQueryOptions<IntegrationManifest[]>,
  'queryKey' | 'queryFn' | 'staleTime'
>;

const INTEGRATION_MANIFESTS_QUERY_KEY = 'INTEGRATION_MANIFESTS';

export function useIntegrationManifests(
  options?: UseIntegrationManifestsProps
) {
  return useQuery({
    ...options,
    queryKey: [INTEGRATION_MANIFESTS_QUERY_KEY],
    queryFn: async () => {
      const url = new URL(
        `${env.NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL}/manifests`
      );
      if (env.NEXT_PUBLIC_CLIENT_TYPE !== 'prod') {
        url.searchParams.append('environment', 'dev');
      }
      return await client(url.toString());
    },
    staleTime: Infinity,
  });
}
